import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fileConstruction" }

import FileConstructionPath from "@/components/fileConstruction/FileConstructionPath.vue";
import FileConstructionContent from "@/components/fileConstruction/FileConstructionConent.vue";
import { useStore } from "vuex";
import { computed, onMounted, onUnmounted } from "vue";
import { FileConstructionActions, FileConstructionGetters, FileConstructionMutations } from "@/store/modules/fileConstruction";
import { useRoute } from "vue-router";


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "FileConstruction"
}
)


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const route = useRoute();
const projectId = computed(() => typeof (route.params.projId) === "string" ?
    route.params.projId : route.params.projId[0]);
const targetId = computed(() => typeof (route.params.targetId) === "string" ?
    route.params.targetId : route.params.targetId[0]);
const nodeToInsert = store.getters[`fileConstruction/${FileConstructionGetters.getCurrentFileConstructionNode}`];
const pid = nodeToInsert.id;
const uid = targetId.value;
const projId = projectId.value;
const filePath = store.getters[`fileConstruction/${FileConstructionGetters.getCurrentPath}`];


onMounted(() => {
    store.dispatch(
        `fileConstruction/${FileConstructionActions.asyncGetChildrenByPid}`,
        { projId, pid, uid, nodeToInsert, filePath },
    );
});

onUnmounted(() => {
    store.commit(`fileConstruction/${FileConstructionMutations.resetAll}`);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(FileConstructionPath),
    _createVNode(FileConstructionContent)
  ]))
}
}

})